import type { FC, PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { useAppSettingStore } from '@/features/profile-setting/store/useAppSettingStore';

export type OrganizationDataExtensionDebugFrameColor =
  | 'organization'
  | 'media'
  | 'dataExtension';

type Props = PropsWithChildren<{
  label: string;
  color?: OrganizationDataExtensionDebugFrameColor;
}>;

const FRAME_COLORS: Record<OrganizationDataExtensionDebugFrameColor, string> = {
  organization: '#1e88e5',
  media: '#8e24aa',
  dataExtension: '#43a047'
};

export const OrganizationDataExtensionDebugFrame: FC<Props> = ({
  label,
  color = 'organization',
  children
}) => {
  const isEnabled = useAppSettingStore(
    (state) => state.isExtensionDebugFrameEnabled
  );

  if (!__DEV__ || !isEnabled) {
    return <>{children}</>;
  }

  const frameColor = FRAME_COLORS[color];

  return (
    <View style={[styles.frame, { borderColor: frameColor }]}>
      <Text variant="labelSmall" style={{ color: frameColor }}>
        {label}
      </Text>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  frame: {
    borderWidth: 1,
    borderStyle: 'dashed',
    borderRadius: 8,
    padding: 8,
    gap: 8
  }
});
